import React from "react";
import { IntervalData } from "../models/ServicePlanModels";
import Collapsible from "../../Collapsible";

export interface ServicePlanPriceIntervalsProps {
  serviceIntervalsList?: IntervalData[];
  showTotals: boolean;
  isServicePlan: boolean;
  selectedModelVariant: string;
}

const ServicePlanPriceIntervals: React.SFC<ServicePlanPriceIntervalsProps> = (
  props
) => {
  const items = [];
  const variantItemsTotals = []; //used for total calculations

  props.serviceIntervalsList.forEach((interval) => {
    const variantItems = [];
    const modelVariantServicePrices = interval.modelVariantServicePrices.filter(
      (modelVariantServicePrice) =>
        !props.selectedModelVariant ||
        modelVariantServicePrice.variantName == props.selectedModelVariant
    );

    modelVariantServicePrices.forEach((variant) => {
      let priceString: string;
      if (variant.isNotApplicable) {
        priceString = "N/A";
      } else if (variant.price == 0) {
        priceString = "Free";
      } else {
        priceString = `$${variant.price.toFixed(2)}`;
      }
      variantItems.push(
        <li key={variant.variantName} className="list-group-item">
          <div className="row">
            <div className="col-xs-9">
              <span>
                {variant.variantName}
                <sup>{props.isServicePlan ? 3 : 2}</sup>
              </span>
            </div>
            <div className="col-xs-3">
              <span>{priceString}</span>
            </div>
          </div>
        </li>
      );
      //used for total calculations
      variantItemsTotals.push({
        variantName: variant.variantName,
        price: variant.price,
      });
    });
    items.push(
      <li className="list-group-item" key={interval.name}>
        <Collapsible title={interval.name.replace("|", "</br>")}>
          <ul className="list-group">{variantItems}</ul>
        </Collapsible>
      </li>
    );
    // Adding 36 months total
    if (props.showTotals && interval.name.includes("36 months")) {
      const variantItems_36 = [];
      modelVariantServicePrices.forEach((variant) => {
        variantItems_36.push(
          <li key={variant.variantName} className="list-group-item">
            <div className="row">
              <div className="col-xs-9">
                <span>
                  {variant.variantName}
                  <sup>3</sup>
                </span>
              </div>
              <div className="col-xs-3">
                <span>
                  $
                  {variantItemsTotals
                    .filter((v) => v.variantName == variant.variantName)
                    .reduce((r, d) => r + d.price, 0)
                    .toFixed(2)}
                </span>
              </div>
            </div>
          </li>
        );
      });

      items.push(
        <li
          className="list-group-item is-total"
          key="Total 3 Year Service Plan Price (including GST)"
        >
          <Collapsible title="Total 3 Year Service Plan Price (including GST)">
            <ul className="list-group">{variantItems_36}</ul>
          </Collapsible>
        </li>
      );
    }
    //Adding all months total
    if (
      props.showTotals &&
      interval ==
        props.serviceIntervalsList[props.serviceIntervalsList.length - 1]
    ) {
      const variantItems_60 = [];
      modelVariantServicePrices.forEach((variant) => {
        variantItems_60.push(
          <li key={variant.variantName} className="list-group-item">
            <div className="row">
              <div className="col-xs-9">
                <span>
                  {variant.variantName}
                  <sup>3</sup>
                </span>
              </div>
              <div className="col-xs-3">
                <span>
                  $
                  {variantItemsTotals
                    .filter((v) => v.variantName == variant.variantName)
                    .reduce((r, d) => r + d.price, 0)
                    .toFixed(2)}
                </span>
              </div>
            </div>
          </li>
        );
      });

      items.push(
        <li
          className="list-group-item is-total"
          key="Total 5 Year Service Plan Price (including GST)"
        >
          <Collapsible title="Total 5 Year Service Plan Price (including GST)">
            <ul className="list-group">{variantItems_60}</ul>
          </Collapsible>
        </li>
      );
    }
  });

  return <ul className="list-group">{items}</ul>;
};

export default ServicePlanPriceIntervals;
